function saveAssignedEmpData(url, getDataUrl) {
    const employeeId = $("#employee_id")
    const tags = $("#tags")
    const data = {
        "employee_id": employeeId.val(),
        "tags": tags.val(),
    }
    $.ajax({
        url: url,
        data: data,
        method: "post",
        dataType: "json",
        success: (data, msg) => {
            if (data) {
                showAssignedEmployeeList(getDataUrl)
                var modalElement = document.getElementById("assignNewEmployee");
                var modal = bootstrap.Modal.getInstance(modalElement);
                modal.hide();
                $(`option[value='${employeeId.val()}']`).remove(); 
            }
        },
        error: (data, msg) => {
            console.log(data, msg)
        }
    })
}

function showAssignedEmployeeList(url) {

    var assignedEmployeeListElement = $("#assigned_employee_list")
    assignedEmployeeListElement.html(`<tr><td colspan="4"><h3 class="text-primary text-center">Loading.......</h3></td></tr>`)

    $.ajax({
        url: url,
        dataType: "json",
        success: (data) => {
            var text = ""
            if (data.length) {
                $.each(data, (index, val) => {
                    console.log(val.employee)
                    var tags = ""
                    $.each(val.tags, (key, tag) => {
                        tags += `<span class="badge bg-secondary">${tag.name.en}</span> `
                    })

                    text += `<tr>
                            <td>
                                ${val.employee?.fname} ${val.employee?.lname}
                                <input id="position" class="position" name="position[${val.id}]" type="hidden" value="${++index}"/>
                            </td>
                            <td>${tags}</td>
                            <td>
                                <div>
                                    <button type="button" class="edit-package btn btn-primary w-55px py-2" title="Click to edit" onclick="editAssignedEmployeeEdit('${val.id}')">
                                        <i class="fas fa-lg fa-fw fa-pencil"></i>
                                    </button>
    
                                    <button type="button" class="btn btn-danger w-55px py-2" title="Click to delete" onclick="deleteAssignedEmployee('${val.id}')">
                                        <span class="fas fa-trash"></span>
                                    </button>
                                </div>
                            </td>
                        </tr>`
                })
            } else {
                text += `<tr><td colspan="4"><h3 class="text-danger text-center">No data Found</h3></td></tr>`
            }

            assignedEmployeeListElement.html(text)
        },
        error: (data, msg) => {
            console.log(data, msg)
        }
    })
}



function editAssignedEmployeeEdit(id) {
    var createButton = $("#create_button")
    var updateButton = $("#update_button")
    createButton.addClass("d-none")
    updateButton.html(`<button type="button" id="update_button" class="btn btn-primary" onclick="updateAssignedEmpData('/orders/assign/employee/automation/${id}/update', '/orders/assign/employee/automation/list')">Update</button>`)

    $.ajax({
        url: `/orders/assign/employee/automation/${id}/show`,
        method: "get",
        success: (data, msg) => {
            const employeeId = $("#employee_id")
            const assignedEmployeeId = data.employee_id
            const tags = data.tags.map(tag => tag.name.en);
            const myModal = new bootstrap.Modal(document.getElementById('assignNewEmployee'))
            myModal.show();
            
            employeeId.append(`<option value='${data.employee.id}'>${data.employee.fname} ${data.employee.lname}</option>`)
            employeeId.val(assignedEmployeeId).change()

            $("#tags").tagit({
                showAutocompleteOnFocus: false,
            })
            $("#tags").tagit("removeAll");
            $.each(tags, (key, tag) => {
                $("#tags").tagit("createTag", tag)
            })

        },
        error: (data, msg) => {
            console.log(data, msg)
        },
    })
}

function updateAssignedEmpData(updateUrl, getDataUrl) {
    const employeeId = $("#employee_id")
    const tags = $("#tags")
    const data = {
        "employee_id": employeeId.val(),
        "tags": tags.val(),
    }

    $.ajax({
        url: updateUrl,
        data: data,
        method: "put",
        dataType: "json",
        success: (data, msg) => {
            if (data) {
                showAssignedEmployeeList(getDataUrl)
                var modalElement = document.getElementById("assignNewEmployee");
                var modal = bootstrap.Modal.getInstance(modalElement);
                modal.hide();
            }
        },
        error: (data, msg) => {
            console.log(data, msg)
        }
    })
}

function resetModal() {
    var createButton = $("#create_button")
    var updateButton = $("#update_button")

    createButton.removeClass("d-none")
    updateButton.html(null)

    $("#employee_id").val("");
    $("#tags").tagit("removeAll");
}

function deleteAssignedEmployee (id) {
    if (confirm("Are you sure?")) {
        $.ajax({
            url:`/orders/assign/employee/automation/${id}/delete`,
            method: "delete",
            dataType: "json",
            success: (data, msg) => {
                if (data) {
                    showAssignedEmployeeList('/orders/assign/employee/automation/list')
                }
            },
            error: (data, msg) => {
                console.log(data, msg)
            }
        })
    }
    
}

function sortList () {
    $("#assigned_employee_list").sortable({
        stop: function( event, ui ) {
            reorderPosition()
        }}
    );
}

function reorderPosition() {
    $(".position").each((key , val) => {
        val.value = ++key
    })

    $.ajax({
        url: "/orders/assign/employee/automation/reposition",
        data: $(".position"),
        dataType: "json",
        method:"put",
        success: (data, msg) => {
            showAssignedEmployeeList('/orders/assign/employee/automation/list')  
        },
        error: (data, msg) => {
            console.log(data, msg)
        }
    })
}

sortList()

window.saveAssignedEmpData = saveAssignedEmpData;
window.showAssignedEmployeeList = showAssignedEmployeeList;
window.editAssignedEmployeeEdit = editAssignedEmployeeEdit;
window.updateAssignedEmpData = updateAssignedEmpData;
window.resetModal = resetModal;
window.deleteAssignedEmployee = deleteAssignedEmployee;
window.sortList = sortList;
window.reorderPosition = reorderPosition;